import useAxiosInstance from "./axiosInstance";
import { useCallback} from 'react';


const useListContainer = (navigate) => {
    const axiosInstance = useAxiosInstance(navigate);
        

    const listContainer = useCallback(async () => {
        try {
            const response = await axiosInstance.get(`/listblob`);
            return response.data;
        } catch (error) {
            console.error("Error retrieving information:", error);
            throw error;
        }
    }, [axiosInstance]);

    return listContainer;
    
};

export default useListContainer;